<template>
  <q-input
    :model-value="humanValue"
    :placeholder="actualPlaceholder"
    :mask="mask"
    v-bind="$attrs"
    @update:model-value="onInput"
    @focus="open"
  />
</template>

<style lang="scss">
@import '~flatpickr/dist/flatpickr.min.css';
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import DatePickerMixin from './DatePickerMixin';

export default defineComponent({
  emits: ['update:modelValue'],
  mixins: [DatePickerMixin],
  props: {
    mask: {
      type: String,
      default: '####/##/##',
    },
    placeholder: String,
  },
  computed: {
    actualPlaceholder(): string {
      return this.placeholder || 'YYYY/MM/DD';
    },
  },
  methods: {
    onInput(value: string) {
      if (value && value.length === 10) {
        if (this.flatpickr) {
          this.flatpickr.setDate(value, true);
        }
      } else {
        this.$emit('update:modelValue', null);
      }
    },
  },
});
</script>
